<template>
  <v-row v-if="!user">
    <v-col cols="12">
      <BaseBlock
        title="Bienvenue sur l'application de la procédure de réorientation de
        l'Université de Lille"
      >
        <div>
          <InfoDates :parametrage="parametrage"></InfoDates>
        </div>
        <v-tabs
          fixed-tabs
          :background-color="colorUnivLille"
          slider-color="white"
          :color="colorUnivLille"
          dark
          v-model="tab"
        >
          <v-tab
            ><v-icon left>mdi-format-list-numbered</v-icon>Les étapes pour se
            réorienter</v-tab
          >
          <v-tab><v-icon left>mdi-information</v-icon>Informations RGPD</v-tab>
        </v-tabs>

        <v-expand-transition>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <InfoSeReorienter
                    :campagnePrecoce="parametrage.campagnePrecoce"
                  >
                  </InfoSeReorienter>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <InfoRGPD> </InfoRGPD>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-expand-transition>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiParametrageRepository from "@/repositories/ApiParametrageRepository";
import { mapState } from "vuex";
import InfoSeReorienter from "../components/InfoSeReorienter.vue";
import InfoRGPD from "../components/InfoRGPD.vue";
import InfoDates from "../components/InfoDates.vue";

export default {
  name: "Home",
  components: { BaseBlock, InfoSeReorienter, InfoRGPD, InfoDates },
  data() {
    return {
      parametrage: {},
      tab: null,
      colorUnivLille: "#1f8388"
    };
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    gotoVue(vueName, paramsVue) {
      if (paramsVue) {
        this.$router.push({ name: vueName, params: paramsVue });
      } else {
        this.$router.push({ name: vueName });
      }
    },
    async getParametrage() {
      try {
        const parametrage = await ApiParametrageRepository.getParametrage(
          this.parametrage
        );

        this.parametrage = parametrage;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    }
  },
  async created() {
    await this.getParametrage();
    if (this.user) {
      if (this.user.roles.indexOf("ROLE_PROFIL_ETUDIANT") > -1) {
        if (this.user.roles.indexOf("ROLE_ETUDIANT") > -1) {
          if (this.parametrage.campagnePrecoce) {
            this.gotoVue("mes-candidatures", null);
          } else {
            this.user.roles.push("ROLE_CAMPAGNE_NORMALE");
            this.gotoVue("inscriptionAtelier", null);
          }
        } else {
          this.gotoVue("mon-profil", null);
        }
      } else if (this.user.roles.indexOf("ROLE_SUAIO") > -1) {
        this.gotoVue("listing-suaio", null);
      } else if (
        this.user.roles.indexOf("ROLE_ENSEIGNANT") > -1 ||
        this.user.roles.indexOf("ROLE_STRUCTURE") > -1
      ) {
        this.gotoVue("listing-enseignant", null);
      } else if (this.user.roles.indexOf("ROLE_ADMIN") > -1) {
        this.gotoVue("parametrage", null);
      } else if (this.user.roles.indexOf("ROLE_SCOLARITE") > -1) {
        this.gotoVue("listing-scolarite", null);
      } else {
        this.gotoVue("unauthorized", null);
      }
    }
  }
};
</script>

<style scoped>
.v-tab {
  border: solid #2c959b;
}
.v-tab.v-tab--active {
  background-color: #ffffff;
  color: #1f8388;
  border: thick double #1f8388;
}
</style>
